<template>
  <div id="main_div">
    <section class="details-product team">
      <!-- Home Decor Elements -->
      <div class="home-decor">
        <div class="home-circle1">
          <img width="100px" :src='"../assets/images/efunding-icon.png"' alt="Icon" />
        </div>
        <div class="home-circle2">
          <img :src='"../assets/images/efunding-icon.png"' alt="Icon" />
        </div>
        <div class="home-circle3">
          <img width="100px" :src='"../assets/images/efunding-icon.png"' alt="Icon" />
        </div>
      </div>

      <!-- Main Container -->
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <!-- Product Details Sidebar -->
            <div class="details-product__sidebar">
              <b-card :img-src="getProductImageUrl" img-alt="Gambar produk" img-top tag="article"
                class="my-4 shadow p-3 mb-5 bg-white rounded">
                <b-card-title>
                  <h3>{{ items.nama_produk }}</h3>
                  <p>{{ items.sub_product_category.name }}</p>
                </b-card-title>

                <b-card-text>
                  <h5>Akad Syariah</h5>
                  <p>{{ items.akad.name }}</p>
                </b-card-text>

                <b-card-text>
                  <h5>Nilai Simpanan Minimal</h5>
                  <p>{{ formatCurrency(items.min_initial_deposit) }}</p>
                </b-card-text>

                <b-card-text v-if="items.akad_id === 1">
                  <h5>Nisbah</h5>
                  <p>{{ items.nisbah }}</p>
                </b-card-text>

                <b-card-text v-if="items.akad_id === 1">
                  <h5>Proyeksi Bagi Hasil (Equal Rate)</h5>
                  <p>{{ $formatPersen(items.equal_rate) }}% p.a.</p>
                </b-card-text>

                <b-button @click.prevent="addPengajuan" variant="custom" class="theme-color text-white px-4 rounded-0">
                  Ajukan Sekarang
                </b-button>
              </b-card>
            </div>

            <!-- Estimated Return Calculation Section -->
            <div v-if="items.akad_id === 1" class="details-product__sidebar">
              <b-card class="my-4 shadow p-3 mb-5 bg-white rounded">
                <b-card-title>
                  <h3 class="mt-0">Estimasi Perhitungan Pengembalian Dana</h3>
                </b-card-title>
                <hr />

                <b-card-text>
                  <h5>Penempatan Dana</h5>
                  <b-form-input v-model="penempatanDana" type="text" @input="formatPenempatanDana"
                    placeholder="Masukkan Penempatan Dana" class="text-center" />
                </b-card-text>

                <b-card-text>
                  <h5>Estimasi Bagi Hasil</h5>
                  <p>
                    {{ formatCurrency(countBagiHasil(items.equal_rate, parseInt(penempatanDana.replace(/\D/g, '')),
                    items.sub_product_category_id)) }}
                  </p>
                </b-card-text>

                <hr />

                <b-card-text>
                  <h5>Estimasi Total Pengembalian</h5>
                  <p style="color: green; font-weight: bold;">
                    {{ formatCurrency(parseInt(penempatanDana.replace(/\D/g, '')) + countBagiHasil(items.equal_rate,
                      parseInt(penempatanDana.replace(/\D/g, '')), items.sub_product_category_id)) }}
                  </p>
                </b-card-text>

                <b-card-text>
                  <h5>Total Pembayaran</h5>
                  <p>{{ formatCurrency(parseInt(penempatanDana.replace(/\D/g, ''))) }}</p>
                </b-card-text>

                <b-card-title>
                  <p style="font-size: small;">*Belum termasuk potongan pajak 20%<br>**Hasil perhitungan ini bersifat estimasi, dapat berubah sewaktu-waktu mengikuti ketentuan bank</p>
                </b-card-title>
              </b-card>
            </div>
          </div>

          <!-- Partner Details and Product Description -->
          <div class="col-md mt-4">
            <div class="details-product__content">
              <b-card class="card shadow p-3 mb-5 bg-white rounded">
                <div>
                  <b-card-title>
                    <h4>Detail Mitra</h4>
                  </b-card-title>

                  <b-card-text>
                    <h5>Nama Perusahaan</h5>
                    <span>{{ items.mitra.mitra_contact.nama_organisasi_perusahaan || 'Tidak Diketahui' }}</span>
                  </b-card-text>

                  <b-card-text>
                    <h5>Lokasi</h5>
                    <span>{{ fullAddress }}</span>
                    <br />
                    <span>{{ detailAddress }}</span>
                  </b-card-text>
                </div>

                <div>
                  <hr />
                  <b-card-title>
                    <h4>Deskripsi Produk</h4>
                  </b-card-title>
                  <b-card-text>
                    <p>{{ items.description }}</p>
                  </b-card-text>
                </div>

                <!-- Conditional Display for Additional Requirements -->
                <div v-if="items.product_category_id === 1">
                  <hr />
                  <b-card-title>
                    <h4>Persyaratan</h4>
                  </b-card-title>
                  <!-- <b-card-text>
                    <h5>Jenis Funder</h5>
                    <span>{{ items.jenisnasabah.name || 'Tidak Diketahui' }}</span>
                  </b-card-text> -->
                  <b-card-text>
                    <h5>Syarat Kepemilikan Rekening</h5>
                    <span>{{ getSyaratKepemilikanRekeningText }}</span>
                    <a v-if="items.syarat_kepemilikan_rekening == 1">
                      <!-- Font Awesome icon (replace with your own icon if needed) -->
                      <i class="fas fa-info-circle text-info ml-2" id="tabungan-info-icon"
                        style="cursor: pointer; font-size: 1.2em;"></i>

                      <!-- Popover content as before -->
                      <b-popover target="tabungan-info-icon" triggers="hover focus" placement="right"
                        title="Informasi Produk Tabungan" content-class="text-left">
                        <template #default>
                          <div>
                            <p><strong>Nama Produk:</strong> {{ product_tabungan.nama_produk || 'Tidak tersedia' }}</p>
                            <p><strong>Deskripsi:</strong> {{ product_tabungan.description || 'Tidak tersedia' }}</p>
                            <p><strong>Biaya Administrasi:</strong> {{
                              formatCurrency(product_tabungan.biaya_administrasi)
                              || 'N/A' }}</p>
                            <p><strong>Setoran Minimum:</strong> {{ formatCurrency(product_tabungan.min_initial_deposit)
                              || 'N/A' }}</p>
                            <p><strong>Penutupan Rekening:</strong> {{
                              formatCurrency(product_tabungan.biaya_penutupan_rekening) || 'N/A' }}</p>
                          </div>
                        </template>
                      </b-popover>
                    </a>
                  </b-card-text>
                </div>

                <!-- Additional Info and Fees Section -->
                <div>
                  <hr />
                  <b-card-title>
                    <h4>Biaya-Biaya</h4>
                  </b-card-title>
                  <div v-for="(biaya, index) in biayaList" :key="index">
                    <b-card-text>
                      <h5>{{ biaya.label }}</h5>
                      <span>{{ formatBiaya(biaya.value) }}</span>
                    </b-card-text>
                  </div>
                </div>

                <!-- Information on Rollover and Dividends -->
                <div v-if="items.product_category_id === 1">
                  <hr />
                  <b-card-title>
                    <h4>Informasi Lainnya</h4>
                  </b-card-title>
                  <b-card-text>
                    <h5>Automatic Roll Over</h5>
                    <span>{{ getAutomaticRollOverText }}</span>
                  </b-card-text>
                  <b-card-text>
                    <h5>Penarikan Bagi Hasil</h5>
                    <span>{{ penarikanBagiHasil }}</span>
                  </b-card-text>
                </div>

                <!-- Requirements for Application Submission -->
                <div>
                  <hr />
                  <b-card-title>
                    <h4>Ulasan</h4>
                  </b-card-title>
                  <b-card-text>
                    <h5>Syarat Pengajuan:</h5>
                    <ul>
                      <li>Calon Nasabah merupakan Warga Negara Indonesia</li>
                      <li>Usia min. 17 tahun dan max. 60 tahun</li>
                    </ul>
                    <h5>Dokumen yang harus disiapkan:</h5>
                    <ul>
                      <li>Kartu Identitas Asli (KTP/SIM/Paspor)</li>
                      <li>NPWP, akte pendirian perusahaan dan perubahan terakhir SIUP / TDP (untuk nasabah korporasi)
                      </li>
                    </ul>
                  </b-card-text>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Modals (Success, Confirmations, Terms) -->
      <b-modal size="l" v-model="successPengajuanModal" centered hide-header>
        <div class="d-block text-center">
          <b-icon v-if="hasDocumentsToSign" icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>

          <h3 :class="textColor"><strong>{{ modalTitle }}</strong></h3>
          <h4 class="font-weight-light">{{ modalText }}</h4>

          <b-alert v-if="hasDocumentsToSign" variant="warning" show class="mt-3 animated-alert">
            Anda memiliki dokumen yang perlu ditandatangani untuk menyelesaikan proses ini. 
            Harap segera melakukan tanda tangan elektronik.
          </b-alert>
        </div>
        <template #modal-footer>
          <b-button @click="successPengajuanModal = false" :variant="buttonColor">
            Tutup
          </b-button>
          <b-button v-if="hasDocumentsToSign" @click="goToSignaturePage" :variant="buttonColor">
            Tandatangani Dokumen
          </b-button>
          <b-button v-if="notifButtonRedirectProfileKycSign" @click="goToChangeSignaturePage" variant="success">
            Atur Tanda Tangan
          </b-button>
        </template>
      </b-modal>

      <b-modal size="lg" v-model="askNewRekeningModal" v-if="items.syarat_kepemilikan_rekening">
        <!-- Modal Body -->
        <div class="text-center p-3">
          <p>
            Untuk melakukan pengajuan <strong>{{ items.nama_produk }}</strong> di 
            <strong>{{ items.mitra.mitra_contact.nama_organisasi_perusahaan }}</strong>,  
            Anda harus memiliki rekening tabungan 
            <strong>
              <a :href="items.product_tabungan_id" class="text-primary">
                {{ product_tabungan.nama_produk }}
              </a>
            </strong>.
          </p>
          <p>
            <strong>Jika belum memiliki rekening tabungan</strong>, kami akan membuatkannya untuk Anda secara otomatis.  
            <strong>Jika sudah memiliki</strong>, Anda hanya perlu memasukkan nomor rekening pada langkah berikutnya.
          </p>
          <p><h3>Apakah Anda sudah memiliki rekening tabungan tersebut?</h3></p>
        </div>

        <!-- Modal Footer: Tombol kiri & kanan -->
        <template #modal-footer>
          <div class="d-flex justify-content-between w-100">
            <b-button @click="iDontHaveRekeningTabungan" variant="primary" class="btn-custom-popup">
              Belum Punya
            </b-button>
            <b-button @click="iHaveRekeningTabungan" variant="success" class="btn-custom-popup">
              Sudah Punya
            </b-button>
          </div>
        </template>
      </b-modal>

      <b-modal size="md" v-model="confirmPengajuanModal" hide-footer hide-header>
        <div class="p-4 text-center">
          <!-- Modal Header -->
          <h3 class="font-weight-bold mb-3 mt-0">Konfirmasi Setoran Awal</h3>
          <!-- <p class="text-muted">Setoran minimal yang harus Anda masukkan adalah <strong>{{ formatCurrency(minimSetoranDeposito) }}</strong>.</p> -->

          <!-- Setoran Awal Input Section with Custom Label -->
          <div class="text-left mb-4">
            <!-- Dynamic Label for Deposit Requirement -->
            <label for="setoran_awal_deposito" class="d-block">
              Nominal setoran awal {{ items.syarat_kepemilikan_rekening ? 'Deposito' : items.sub_product_category.name
              }}
              minimal adalah <strong>{{ formatCurrency(minimSetoranDeposito) }}</strong>
            </label>

            <!-- Deposit Amount Input with Currency Symbol -->
            <b-form-group label-for="setoran_awal_deposito">
              <b-input-group>
                <!-- <b-input-group-prepend is-text>IDR</b-input-group-prepend> -->
                <b-form-input id="setoran_awal_deposito" v-model="setoran_awal_deposito"
                  @input="formatSetoranAwalDeposito"
                  :placeholder="`Masukkan Setoran Awal ${items.syarat_kepemilikan_rekening ? 'Deposito' : items.sub_product_category.name}`"
                  class="text-center" type="text" />
              </b-input-group>
            </b-form-group>
          </div>


          <!-- Conditional Account Information Section -->
          <div v-if="items.syarat_kepemilikan_rekening" class="my-4">
            <b-card no-body bg-variant="light" class="shadow-sm">
              <b-card-body>
                <p v-if="is_new_rekening" class="text-muted">
                  <b-icon icon="info-circle" class="text-primary mr-2"></b-icon>
                  Sistem akan otomatis membuat tabungan baru untuk produk <strong><a :href="items.product_tabungan_id"
                      class="text-primary">{{ product_tabungan.nama_produk }}</a></strong>.
                </p>

                <label for="setoran_awal_tabungan" class="d-block" v-if="is_new_rekening">
                  Nominal setoran awal Tabungan minimal adalah <strong>{{ formatCurrency(minimSetoranTabungan) }}</strong>
                </label>
                <!-- Setoran Awal Tabungan Input -->
                <b-form-group label-for="setoran_awal_tabungan" v-if="is_new_rekening" class="mt-2 mb-3">
                  <b-input-group>
                    <!-- <b-input-group-prepend is-text>IDR</b-input-group-prepend> -->
                    <b-form-input id="setoran_awal_tabungan" v-model="setoran_awal_tabungan"
                      @input="formatSetoranAwalTabungan" placeholder="Masukkan Setoran Awal Tabungan"
                      class="text-center" type="text" />
                  </b-input-group>
                </b-form-group>

                <!-- Nomor Rekening Tabungan Input -->
                <b-form-group label="Nomor Rekening Tabungan" label-for="nomor_rekening_tabungan"
                  v-if="!is_new_rekening" class="mt-2 mb-3">
                  <b-form-input id="nomor_rekening_tabungan" v-model="form.nomor_rekening_tabungan"
                    placeholder="Masukkan Nomor Rekening" class="text-center" type="text" />
                </b-form-group>
              </b-card-body>
            </b-card>
          </div>

          <!-- Action Buttons Section -->
          <div class="d-flex justify-content-between mt-4">
            <b-button variant="outline-danger" @click="hideConfirmPengajuanModal" class="px-4">
              <b-icon icon="x-circle" class="mr-2"></b-icon>Batal
            </b-button>
            <b-button variant="outline-success" @click="showSyaratPengajuanModal" class="px-4">
              <b-icon icon="check-circle" class="mr-2"></b-icon>Ajukan
            </b-button>
          </div>
        </div>
      </b-modal>

      <b-modal size="lg" v-model="syaratPengajuanModal">
        <div class="d-block text-center">
          <h3 class="mt-0"><strong>Syarat Dan Ketentuan<br>Pembukaan Rekening Tabungan Dan Deposito</strong></h3>
          <ol class="text-left">
            <li>Untuk pengajuan deposito dan pembukaan tabungan yang pertama pada setiap Bank Perekonomian Rakyat Syariah
              (“BPRS”), BPRS akan menghubungi calon nasabah untuk proses validasi data dalam rentang waktu 3 hari kerja
              (Senin
              – Jumat).</li>
            <li>Apabila pembayaran deposito dan/atau setoran pembukaan tabungan diterima setelah jam 13.30 WIB pada hari
              kerja, maka transaksi akan diproses pada hari kerja berikutnya.</li>
            <li>BPRS hanya akan menerima uang dalam mata uang rupiah.</li>
            <li>Bergantung pada ketentuan pada masing-masing BPRS, bagi hasil deposito dapat dicairkan bersamaan dengan
              nilai
              pokok deposito pada tanggal jatuh tempo sesuai dengan yang tertera dalam Advis Deposito atau dicairkan
              pada
              setiap bulannya selama jangka waktu Deposito (“Tanggal Pencairan Bagi Hasil”).</li>
            <li>Untuk produk Automatic Roll Over (“ARO”) (hanya untuk produk deposito):
              <ul style="list-style-type: lower-alpha;">
                <li>Seluruh bagi hasil deposito akan dicairkan dan ditransfer ke rekening deposan;</li>
                <li>Nilai pokok deposito kemudian akan diperpanjang sesuai dengan tenor dan presentase bagi hasil yang
                  sama.
                </li>
              </ul>
            </li>
            <li>Apabila Tanggal Pencairan Bagi Hasil berada pada hari libur/diluar hari operasional BPRS, maka pencairan
              akan
              dilakukan pada hari kerja berikutnya.</li>
            <li>Penjaminan deposito oleh Lembaga Penjamin Simpanan (“LPS”) mengacu pada tingkat suku bunga penjaminan
              LPS pada
              saat ikatan awal pembukaan deposito atau tabungan, terlepas dari penurunan dan kenaikan suku bunga
              penjaminan
              LPS dikemudian hari.</li>
            <li>Jika pemilik deposito atau tabungan meninggal dunia, deposito atau tabungan atas namanya dapat
              diserahkan/dialihkan kepada ahli waris.</li>
          </ol>
        </div>
        <template #modal-footer>
          <b-button @click="hideSyaratPengajuanModal" variant="primary">Setuju dan Lanjutkan</b-button>
        </template>
      </b-modal>

      <b-modal size="m" v-model="notfulfillModal">
        <div class="d-block text-center">
          <h3><strong>Profil Belum Lengkap</strong></h3>
          <h4 class="font-weight-light">Silahkan lengkapi profil Anda Terlebih Dahulu !</h4>
        </div>
        <template #modal-footer>
          <b-button @click="notfulfillModalKlik" variant="primary">Oke</b-button>
        </template>
      </b-modal>

      <b-modal size="m" v-model="notifConfirmPengajuan">
        <div class="d-block text-center">
          <h3><strong>Konfirmasi Pengajuan</strong></h3>
          <h4 class="font-weight-light">Apakah Anda Yakin ?</h4>
        </div>
        <template #modal-footer>
          <div v-if="loading" class="text-center">
            <b-spinner variant="primary"></b-spinner>
          </div>
          <div v-else>
            <b-button @click="cancelPengajuan" variant="danger">Tidak</b-button>
            <b-button @click="notifConfirmPengajuanKlik" variant="primary">Ya</b-button>
          </div>
        </template>
      </b-modal>

      <b-modal size="m" v-model="successPengajuan">
        <div class="d-block text-center">
          <h3><strong>Pengajuan Berhasil!</strong></h3>
          <h4 class="font-weight-light">Pengajuan Anda Berhasil</h4>
          </div>
        <template #modal-footer>
          <b-button @click="successPengajuanKlik" variant="primary">Oke</b-button>
        </template>
      </b-modal>

      <b-modal size="m" v-model="rejectionBlockModal" hide-header centered>
        <div class="d-block text-center p-3">
          <b-icon icon="exclamation-octagon-fill" variant="danger" style="width: 80px; height: 80px;" class="mb-3"></b-icon>
          <h3><strong>Pengajuan Ditangguhkan</strong></h3>
          <p class="text-muted">Mohon maaf, Anda belum dapat melakukan pengajuan baru karena terdapat pengajuan sebelumnya yang memerlukan <strong>perbaikan data profil</strong>.</p>
          <div v-if="activeRejectionFields.length > 0" class="mt-3 text-left bg-light p-3 rounded">
            <p class="mb-2 font-weight-bold"><b-icon icon="list-check" class="mr-1"></b-icon> Data atau informasi yang memerlukan perbaikan:</p>
            <div class="d-flex flex-wrap">
              <b-badge v-for="field in activeRejectionFields" :key="field" variant="warning" class="mr-1 mb-1 p-2 text-dark border border-dark">
                {{ formatFieldLabel(field) }}
              </b-badge>
            </div>
          </div>
          <p class="mt-3">Silahkan perbarui data profil Anda terlebih dahulu sebelum melakukan pengajuan kembali.</p>
        </div>
        <template #modal-footer>
          <b-button @click="rejectionBlockModal = false" variant="secondary">Tutup</b-button>
          <b-button @click="goToProfileUpdate" variant="primary">Perbarui Profil Sekarang</b-button>
        </template>
      </b-modal>
    </section>
    <Footer />
    <js />
  </div>
</template>

<script>
import Product from '../api/produk';
import Pengajuan from '../api/pengajuan';
import Funder from '../api/funder';
import Provinsi from "../api/daerahindonesia/provinsi";
import Kota from "../api/daerahindonesia/kota";

export default {
  name: 'DetailProduk',
  data() {
    return {
      items: {},
      product_tabungan: null,
      form: {
        product_id: null,
        funder_id: null,
        mitra_id: null,
        setoran_awal: null,
        setoran_awal_tabungan: null,
        nomor_rekening_tabungan: null,
        is_new_rekening: null,
      },
      askNewRekeningModal: false,
      successPengajuanModal: false,
      successPengajuan: false,
      confirmPengajuanModal: false,
      handleCancelnotifConfirmPengajuan: false,
      syaratPengajuanModal: false,
      modalTitle: '',
      modalText: '',
      textColor: '',
      currentUser: null,
      loading: false,
      notifConfirmPengajuan: false,
      notifButtonRedirectProfileKycSign: false,
      successPengajuanKlik: false,
      minimSetoranDeposito: 0,
      maximumSetoranDeposito: 0,
      minimSetoranTabungan: 0,
      setoran_awal_deposito: null,
      setoran_awal_tabungan: null,
      is_new_rekening: null,
      penempatanDana: '',
      options: {
        provinsi: [],
        kota: [],
        dataPenarikanBagHa: [
          { text: 'Tiap Bulan', value: 'tiap-bulan' },
          { text: 'Akhir Periode', value: 'akhir-periode' },
        ]
      },
      notfulfillModal: false,
      hasDocumentsToSign: false,
      pengajuan_id: null,
      rejectionBlockModal: false,
      activeRejectionFields: [],
    };
  },
  created() {
    this.currentUser = this.$store.state.auth.user || null;
    this.loadData();
  },
  computed: {
    tabunganTooltipText() {
      const tabungan = this.product_tabungan;
      if (tabungan) {
        return `
          Nama Produk: ${tabungan.nama_produk}\n
          Deskripsi: ${tabungan.description}\n
          Biaya Administrasi: ${this.formatCurrency(tabungan.biaya_administrasi)}\n
          Minimum Setoran: ${this.formatCurrency(tabungan.min_initial_deposit)}\n
          Biaya Penutupan Rekening: ${this.formatCurrency(tabungan.biaya_penutupan_rekening) || 'N/A'}
        `;
      }
      return 'Informasi produk tabungan tidak tersedia';
    },
    getProductImageUrl() {
      return this.items.mitra && this.items.mitra.mitra_profile
        ? this.items.mitra.mitra_profile.logo_mitra
        : '';
    },
    getSyaratKepemilikanRekeningText() {
      return this.items.syarat_kepemilikan_rekening === 0
        ? 'Tidak'
        : this.items.syarat_kepemilikan_rekening === 1
          ? 'Ya'
          : 'Tidak Diketahui';
    },
    getAutomaticRollOverText() {
      return this.items.automatic_roll_over === 0
        ? 'Tidak'
        : this.items.automatic_roll_over === 1
          ? 'Ya'
          : 'Tidak Diketahui';
    },
    biayaList() {
      return [
        { label: 'Biaya administrasi', value: this.items.biaya_administrasi },
        { label: 'Biaya di Bawah Saldo Minimum', value: this.items.biaya_dibawah_saldo_minimum },
        { label: 'Biaya Penutupan Rekening', value: this.items.biaya_penutupan_rekening },
        { label: 'Biaya Penarikan Sebelum Jatuh Tempo', value: this.items.biaya_penarikan_sebelum_jatuh_tempo },
        { label: 'Biaya ' + (this.items.keterangan ? this.items.keterangan : 'Lainnya'), value: this.items.biaya_lain_lain },
      ];
    },
    fullAddress() {
      return `${this.items.mitra.mitra_profile.alamat_mitra}`;
    },
    detailAddress() {
      const province = this.options.provinsi.find(p => p.value == this.items.mitra.mitra_profile.provinsi);
      const city = this.options.kota.find(c => c.value == this.items.mitra.mitra_profile.kota);
      return ` ${city ? city.text : 'Tidak Diketahui'}, ${province ? province.text : 'Tidak Diketahui'}.`;
    },
    penarikanBagiHasil() {
      const penarikanBagHa = this.options.dataPenarikanBagHa.find(p => p.value == this.items.penarikan_bagi_hasil);
      return penarikanBagHa ? penarikanBagHa.text : 'Tidak Diketahui';
    },
  },
  methods: {
    formatSetoranAwalDeposito() {
      const value = this.setoran_awal_deposito.replace(/\D/g, '');
      this.setoran_awal_deposito = value ? this.formatCurrency(value) : '';
    },
    formatSetoranAwalTabungan() {
      const value = this.setoran_awal_tabungan.replace(/\D/g, '');
      this.setoran_awal_tabungan = value ? this.formatCurrency(value) : '';
    },
    iHaveRekeningTabungan() {
      this.is_new_rekening = false;
      this.askNewRekeningModal = false;
      this.confirmPengajuanModal = true;
    },
    iDontHaveRekeningTabungan() {
      this.is_new_rekening = true;
      this.askNewRekeningModal = false;
      this.confirmPengajuanModal = true;
    },
    notifConfirmPengajuanKlik() {
      if (!this.currentUser) {
        this.$router.push('/login');
        return;
      }

      const { role_id } = this.currentUser.info;

      if (role_id === 4 || role_id === 3) {
        if (this.isSetoranAwalValid()) {
          this.confirmPengajuanModal = false;
          this.submitPengajuan();
        } else {
          this.showPengajuanFailedModal(
            'Anda harus mengisi nominal setoran awal anda setara atau lebih besar dari setoran minimal',
            'text-danger'
          );
        }
      } else if (role_id === 2 || role_id === 5) {
        this.showPengajuanFailedModal(
          'Pengajuan hanya bisa dilakukan oleh nasabah. Silahkan berpindah akun menjadi nasabah',
          'text-danger'
        );
      } else {
        this.$router.push('/login');
      }
    },
    successPengajuanKlik() {
      this.successPengajuan = false;
      this.$router.push('/list-produk');
    },
    goToSignaturePage() {
      this.successPengajuan = false;

      const pengajuanId = this.pengajuan_id;
      if (pengajuanId) {
        this.$router.push({
          path: '/pengajuan-saya',
          query: {
            pengajuan_id: pengajuanId,
            action: 'show'
          }
        });
      } else {
        console.log("Gagal mendapatkan pengajuan ID");
        this.$router.push('/pengajuan-saya');
      }
    },
    goToChangeSignaturePage() {
      this.$router.push({
        path: '/pengajuan-saya',
        query: {
          q: 'KycSign'
        }
      });
    },
    notfulfillModalKlik() {
      this.notfulfillModal = false;
      this.$router.push('/pengajuan-saya?q=Profil');
    },
    goToProfileUpdate() {
      this.rejectionBlockModal = false;
      this.$router.push('/pengajuan-saya?q=Profil');
    },
    loadData() {
      Product.funderShow(this.$route.params.id)
        .then((res) => {
          const productData = res.data.data;
          if (!productData || Object.keys(productData).length === 0) {
            this.$bvToast.toast('Produk tidak ditemukan. Silakan coba lagi atau hubungi administrator.', {
              title: 'Produk Tidak Ditemukan',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            });
            setTimeout(() => {
              this.$router.push('/list-produk');
            }, 1500);
            return;
          }

          this.items = productData;
          this.form.product_id = this.items.id;
          this.form.mitra_id = this.items.mitra_id;

          if (this.currentUser) {
            this.form.funder_id = this.currentUser.info.id;
          }

          this.minimSetoranDeposito = parseInt(this.items.min_initial_deposit, 10);
          this.maximumSetoranDeposito = parseInt(this.items.max_initial_deposit, 10);

          Provinsi.index()
            .then((res) => {
              let resData = res.data.provinsi;
              const arrData = [];
              for (let i = 0; i < resData.length; i++) {
                arrData.push({
                  value: resData[i].id,
                  text: resData[i].nama,
                });
              }
              this.options.provinsi = arrData;
            })
            .catch((err) => console.log(err));

          Kota.index(this.items.mitra.mitra_profile.provinsi)
            .then((res) => {
              let resData = res.data.kota_kabupaten;
              const arrData = [];
              for (let i = 0; i < resData.length; i++) {
                arrData.push({
                  value: resData[i].id,
                  text: resData[i].nama,
                });
              }
              this.options.kota = arrData;
            })
            .catch((err) => console.log(err));

          if (this.items.syarat_kepemilikan_rekening) {
            Product.funderShow(this.items.product_tabungan_id)
              .then((res) => {
                this.product_tabungan = res.data.data;
                this.minimSetoranTabungan = parseInt(this.product_tabungan.min_initial_deposit, 10);
              })
              .catch((err) => console.log(err));
          }
        })
        .catch((err) => {
          console.error('Error loading product:', err);
          this.$bvToast.toast('Terjadi kesalahan saat memuat data produk. Silakan coba lagi nanti.', {
            title: 'Kesalahan',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(value);
    },
    formatBiaya(value) {
      return value !== null ? this.formatCurrency(value) : 'Tidak Ada';
    },
    confirmAddPengajuan() {
      this.notifConfirmPengajuan = true;
    },
    isSetoranAwalValid() {
      const val_setoran_awal_dep = parseInt(this.setoran_awal_deposito.replace(/\D/g, ''), 10);
      if (val_setoran_awal_dep >= this.minimSetoranDeposito) {
        if (this.items.syarat_kepemilikan_rekening == 1 && this.is_new_rekening == true || this.items.syarat_kepemilikan_rekening == true && this.is_new_rekening == true) {
          const val_setoran_awal_tab = parseInt(this.setoran_awal_tabungan.replace(/\D/g, ''), 10);
          return val_setoran_awal_tab >= this.minimSetoranTabungan;
        }
        return true;
      } else {
        return false;
      }
    },
    async submitPengajuan() {
      this.loading = true;

      try {
        const val_setoran_awal_dep = parseInt(this.setoran_awal_deposito.replace(/\D/g, '') || "0", 10) || 0;
        this.form.setoran_awal = val_setoran_awal_dep;
        this.form.is_new_rekening = this.is_new_rekening;

        if (this.is_new_rekening) {
          const val_setoran_awal_tab = parseInt(this.setoran_awal_tabungan.replace(/\D/g, '') || "0", 10) || 0;
          this.form.setoran_awal_tabungan = val_setoran_awal_tab;
        }

        const response = await Pengajuan.store(this.form);

        if (response.data.meta.code === 200) {
          this.pengajuan_id = response.data.data.id;
          this.notifConfirmPengajuan = false;
          this.showPengajuanSuccessModal(response.data.meta.message || "Pengajuan berhasil!", 'text-success');
        } else if (response.data.meta.code === 4401) {
          this.notifConfirmPengajuan = false;
          this.notifButtonRedirectProfileKycSign = true;
          this.showPengajuanFailedModal(response.data.meta.message || "Terjadi kesalahan!", 'text-danger');
        } else {
          this.notifConfirmPengajuan = false;
          this.notifButtonRedirectProfileKycSign = false;
          this.showPengajuanFailedModal(response.data.meta.message || "Terjadi kesalahan!", 'text-danger');
        }
      } catch (error) {
        console.error("Terjadi kesalahan saat mengirim pengajuan:", error);
        this.showPengajuanFailedModal("Terjadi kesalahan saat mengirim pengajuan!", 'text-danger');
      } finally {
        this.loading = false;
      }
    },
    showPengajuanFailedModal(messageModal, textColor) {
      this.modalTitle = 'Pengajuan Gagal';
      this.buttonColor = 'danger';
      this.modalText = messageModal;
      this.textColor = textColor;
      this.confirmPengajuanModal = false;
      this.successPengajuanModal = true;
    },
    showPengajuanSuccessModal(message, textColor) {
      this.modalTitle = 'Pengajuan Berhasil';
      this.buttonColor = 'success';
      this.modalText = message;
      this.textColor = textColor;
      this.hasDocumentsToSign = true;
      this.confirmPengajuanModal = false;
      this.successPengajuanModal = true;
    },
    async addPengajuan() {
      if (this.currentUser) {
        this.loading = true;
        try {
          // 1. Ambil data pengajuan untuk cek penolakan
          const resSub = await Pengajuan.pengajuanFunder();
          const dataList = Array.isArray(resSub.data.data) ? resSub.data.data : (resSub.data.data.data || []);
          
          // 2. Ambil data profil untuk cek waktu update terakhir
          const resProf = await Funder.show(this.currentUser.info.id);
          const userProfile = resProf.data.data ? resProf.data.data.profile : null;

          // Cari pengajuan terakhir yang ditolak secara final (status_pengajuan_id: 4)
          // Status 13 tidak lagi memblokir pengajuan baru sesuai instruksi terbaru
          const rejectedSubmissions = dataList.filter(item => item.status_pengajuan_id == 4);
          
          if (rejectedSubmissions.length > 0) {
            // Sortir untuk mendapatkan yang terbaru
            rejectedSubmissions.sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at));
            const latestRejected = rejectedSubmissions[0];
            
            const profileUpdatedAt = userProfile ? new Date(userProfile.updated_at) : new Date(0);
            const rejectionUpdatedAt = new Date(latestRejected.updated_at || latestRejected.created_at);

            // Jika profil BELUM diperbarui setelah penolakan, maka blokir
            if (profileUpdatedAt <= rejectionUpdatedAt) {
              let allFields = [];
              rejectedSubmissions.forEach(sub => {
                if (sub.rejection_detail_fields) {
                  allFields = [...allFields, ...sub.rejection_detail_fields];
                }
              });
              this.activeRejectionFields = [...new Set(allFields)];
              this.rejectionBlockModal = true;
              this.loading = false;
              return;
            }
          }

          // Jika tidak ada penolakan yang menghalangi, lanjut ke pengecekan kelengkapan data
          const response = await Pengajuan.getIsFillFunderData();
          if (response.data.data === 'ready') {
            if (this.items.syarat_kepemilikan_rekening == true) {
              this.setoran_awal_deposito = null;
              this.setoran_awal_tabungan = null;
              this.nomor_rekening_tabungan = null;
              this.askNewRekeningModal = true;
            } else {
              this.setoran_awal_deposito = null;
              this.confirmPengajuanModal = true;
            }
          } else if (response.data.data.length === 0) {
            this.notfulfillModal = true;
          }
        } catch (error) {
          console.error("Error checking rejection status:", error);
        } finally {
          this.loading = false;
        }
      }
    },
    continueAfterRejectionCheck() {
      Pengajuan.getIsFillFunderData().then((response) => {
        if (response.data.data === 'ready') {
          if (this.items.syarat_kepemilikan_rekening == true) {
            this.setoran_awal_deposito = null;
            this.setoran_awal_tabungan = null;
            this.nomor_rekening_tabungan = null;
            this.askNewRekeningModal = true;
          } else {
            this.setoran_awal_deposito = null;
            this.confirmPengajuanModal = true;
          }
        } else if (response.data.data.length === 0) {
          this.notfulfillModal = true;
        }
      });
    },
    hideSuccessPengajuanModal() {
      this.successPengajuanModal = false;
      this.hasDocumentsToSign = false;
    },
    hideConfirmPengajuanModal() {
      this.confirmPengajuanModal = false;
    },
    cancelPengajuan() {
      this.notifConfirmPengajuan = false;
      this.confirmPengajuanModal = false;
    },
    formatPenempatanDana() {
      const value = this.penempatanDana.replace(/\D/g, '');
      this.penempatanDana = value ? this.formatCurrency(value) : '';
    },
    countBagiHasil(equalRate, simpananMinimum, subcategoryid) {
      let tenor = null;
      switch (subcategoryid) {
        case 1:
          tenor = 1;
          break;
        case 2:
          tenor = 3;
          break;
        case 3:
          tenor = 6;
          break;
        case 4:
          tenor = 12;
          break;
        default:
          tenor = 1;
          break;
      }
      return equalRate / 100 * tenor / 12 * simpananMinimum;
    },
    showSyaratPengajuanModal() {
      if (!this.currentUser) {
        this.$router.push('/login');
        return;
      }

      const { role_id } = this.currentUser.info;

      if (role_id === 4 || role_id === 3) {
        if (this.isSetoranAwalValid()) {
          this.syaratPengajuanModal = true;
          this.confirmPengajuanModal = false;
        } else {
          this.showPengajuanFailedModal(
            'Anda harus mengisi nominal setoran awal yang setara atau lebih besar dari setoran minimal, dan lebih kecil atau setara dengan setoran maksimal',
            'text-danger'
          );
        }
      } else if (role_id === 2 || role_id === 5) {
        this.showPengajuanFailedModal(
          'Pengajuan hanya bisa dilakukan oleh nasabah. Silahkan berpindah akun menjadi nasabah',
          'text-danger'
        );
      } else {
        this.$router.push('/login');
      }
    },
    hideSyaratPengajuanModal() {
      this.syaratPengajuanModal = false;
      this.notifConfirmPengajuan = true;
    },
    formatFieldLabel(f) {
      if (!f) return '';
      const fieldKey = f.toLowerCase().replace(/ /g, '_');
      
      // Special Mappings
      if (fieldKey.includes('nama_pihak_terkait') || fieldKey.includes('related_party_name')) return 'NAMA AHLI WARIS';
      if (fieldKey.includes('hubungan_pihak_terkait') || fieldKey.includes('related_party_relationship')) return 'HUBUNGAN AHLI WARIS';
      if (fieldKey.includes('no_hp_pihak_terkait') || fieldKey.includes('related_party_phone')) return 'NOMOR TELEPON AHLI WARIS';
      if (fieldKey.includes('alamat_pihak_terkait') || fieldKey.includes('related_party_address')) return 'ALAMAT AHLI WARIS';
      if (fieldKey === 'pihak_terkait') return 'AHLI WARIS';
      
      if (fieldKey === 'npwp_attachment' || fieldKey === 'taxpayer_document_path') return 'NPWP GAMBAR / PDF';
      if (fieldKey === 'alamat_terkini' || fieldKey === 'current_address') return 'ALAMAT DOMISILI';
      if (fieldKey === 'ratarata_penghasilan_perbulan' || fieldKey === 'estimated_transaction_value') return 'RATA-RATA PENGHASILAN DALAM 1 BULAN';
      if (fieldKey === 'nama_tempatkerja' || fieldKey === 'company_name') return 'NAMA TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'alamat_tempatkerja' || fieldKey === 'company_address') return 'ALAMAT TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'jabatan' || fieldKey === 'position_id') return 'JABATAN';
      if (fieldKey === 'bank_id' || fieldKey === 'bank') return 'NAMA BANK';
      if (fieldKey === 'account_number') return 'NOMOR REKENING';
      if (fieldKey === 'account_name') return 'NAMA PEMILIK REKENING';
      if (fieldKey === 'taxpayer_number' || fieldKey === 'npwp') return 'NPWP';
      if (fieldKey === 'identity_number') return 'NOMOR IDENTITAS / KTP';
      if (fieldKey === 'gender' || fieldKey === 'jenis_kelamin') return 'JENIS KELAMIN';
      if (fieldKey === 'identity_address' || fieldKey === 'alamat') return 'ALAMAT KTP';
      if (fieldKey === 'place_of_birth' || fieldKey === 'tempat_lahir') return 'TEMPAT LAHIR';
      if (fieldKey === 'date_of_birth' || fieldKey === 'tanggal_lahir') return 'TANGGAL LAHIR';
      if (fieldKey === 'nationality' || fieldKey === 'kewarganegaraan') return 'KEWARGANEGARAAN';
      
      return f.replace(/_id$/i, '').replace(/_/g, ' ').toUpperCase();
    }
  },
};
</script>

<style>
.team {
  background-image: url(/static/img/team-bg.16ec647.png);
  width: 100vw;
  background-repeat: no-repeat;
  background-size: auto;
  position: relative;
  background-position: 0 -100px;
}

.home-decor .home-circle1 {
  top: 28rem;
  right: 165px;
}

.home-decor .home-circle2 {
  top: 32rem;
  right: 165px;
}

.home-decor .home-circle3 {
  top: 50rem;
  right: 205px;
}

.btn-custom {
  transition: background 0.4s ease, transform 0.3s ease;
  border: none;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.15);
}

.btn-custom:hover {
  transform: scale(1.08);
  box-shadow: 4px 6px 10px rgba(0, 0, 0, 0.2);
}

/* Efek Hover Ikon Informasi */
#tabungan-info-icon:hover {
  transform: scale(1.3);
  transition: color 0.3s ease, transform 0.3s ease;
}

/* Efek Transisi pada Modal */
.b-modal .modal-content {
  border-radius: 15px;
  transition: all 0.3s ease-in-out;
  transform: scale(0.95);
}

.b-modal.show .modal-content {
  transform: scale(1);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
}

h3 {
  font-weight: bold;
}

h5 {
  color: #284c8d;
}

/* Styling modal footer agar tombol sejajar */
.modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

/* Styling tombol "Belum Punya" (Merah) */
.btn-custom-popup {
  width: 48%;
  font-weight: 700;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.15);
}

/* ✅ Efek Animasi Ikon Sukses */
.animated-icon {
  animation: bounceIn 0.6s ease-in-out;
}

/* ⚠️ Animasi Peringatan Dokumen */
.animated-alert {
  animation: fadeIn 0.8s ease-in-out;
}

/* 🎬 Animasi Bounce In */
@keyframes bounceIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* 🔥 Animasi Fade In */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/detail-produk.vue